import React,{useState,useEffect,useRef} from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Label,
    FormGroup,
    Input,
    Table,
    Row,
    Col,
    Modal,
    ModalBody,
    CustomInput,
  } from "reactstrap";
  import ReactBSAlert from "react-bootstrap-sweetalert";
  import {PENDING_CHANNELS,CHANNEL_TEMPLATES_APPROVE,APPROVED_CHANNELS} from "../../constants"
import axios from "axios";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";



let category = [
  { value: "1", label: "Marketing" },
  { value: "2", label: "Utility" },
  { value: "3", label: "Authentication" },
  { value: "4", label: "Service" },

];

const ApprovedChannels=()=>{
    const [alert, setAlert] = useState(null);
    const [templates, setTemplates] = useState([]);
    const notificationAlertRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    useEffect(()=>{
      getPendingChannels(1);
    },[])

    const getPendingChannels=(pageNo)=>{
    
      setCurrentPage(pageNo);
 
      axios.get(PENDING_CHANNELS+ "?page=" + pageNo+"&status=1&client_id="+user?.client).then(res=>{setTemplates(res?.data)
        setIsLoading(false)
      }).catch((err)=>{
        let options={}
         options = {
          place: "tr",
          message: "Unable to fetch records",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current.notificationAlert(options);
        console.log(err)})
    }
   
    return (
      <>
        <div className="content pd-0 ">
        {alert}
          <Row className="Roles">
            <Card >
              <CardBody className="tableheightwf">
                <h3> Approved Templates</h3>
              <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
              <NotificationAlert ref={notificationAlertRef} />
                <Col sm="12">
                  <Row>
                    <Table responsive striped>
                      <thead >
                        <tr>
                          <th>Sno</th>
                          <th>Channel</th>
                          <th>Template Id</th>
                          <th>Category </th>
                          <th>Sender Id</th>
                          <th>Content</th>
                          <th>Status</th>

                        </tr>
                      </thead>

                      <tbody>
                        
                        {
                        templates?.data?.length>0?templates?.data?.map((item,index)=>{
                          
                            return(
                              <tr>
                                 <td style={{width: "5%"}}> {++index}</td>
                                 <td style={{width: "10%"}}> {item.channels_type}</td>
                                 <td style={{width: "10%", wordBreak:"break-all" }}> {item.template}</td>
                                 <td style={{width: "10%"}}> {item?.category&&item?.category=="1"?"Marketing":item?.category=="2"?"Utility":item?.category=="3"?"Authentication":item?.category=="4"?"Service":""}</td>
                                 <td style={{width: "10%"}}> {item.senderid}</td>
                                 <td style={{width: "10%"}}> {item.content}</td>
                                 <td style={{width: "10%"}}> {item.is_approved==1?"Approved":"Pending"}</td>

                               
                              </tr>
                            )
                          }):<tr>
                            <td colSpan={7}>No Records Found</td>
                          </tr>

                        }
                        
                      </tbody>
                    </Table>
                  </Row>
                </Col>
              </CardBody>
              {templates?.num_of_pages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={templates?.num_of_pages}
                  onPageChange={(newPage) => {
                    getPendingChannels(newPage);
                  }}
                />
              </div>
            )}
            </Card>
          </Row>
        </div>
      </>
    );
}

export default ApprovedChannels;